import React, { FunctionComponent } from 'react';
import { styled } from '@mui/material';

import { StyledTableCell, StyledTableRow } from '../V2/Table/type1/TableStyles';
import BasicLoader from './BasicLoader';

const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingTop: '30px',
  paddingBottom: '30px',
  // padding: theme.spacing(8, 2),
}));

const TableLoader: FunctionComponent = () => {
  return (
    <StyledTableRow>
      <StyledTableCell colSpan={12} sx={{ borderBottom: 'none' }}>
        <RootStyle>
          <BasicLoader />
        </RootStyle>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default TableLoader;
